import { GraduationCap, Check, MessageCircle, Video, BadgeIndianRupee } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { COURSES, waLink } from "../data/site";

export const Courses = () => {
    return (
        <section id="courses" data-testid="courses-section" className="py-28 lg:py-36 px-6 bg-[#0B1730] border-y border-white/5">
            <div className="max-w-6xl mx-auto">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <Overline>Learn With Maitrii</Overline>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F0EBE0]">
                        Learn. <span className="italic text-[#C9A962]">Decode.</span> Transform.
                    </h2>
                    <p className="mt-4 text-sm font-light text-[#A19D94]">
                        Limited seats. Certificate of completion included. Taught personally by Maitrii Shahh.
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                    {COURSES.map((c, i) => (
                        <Reveal key={c.name} delay={i * 0.15} className="h-full">
                            <div data-testid={`course-card-${i}`}
                                className="relative rounded-2xl border border-white/10 bg-[#0E1B33] p-8 lg:p-10 h-full flex flex-col hover:-translate-y-1 hover:border-[#C9A962]/30 hover:shadow-[0_0_50px_rgba(201,169,98,0.12)] transition-all duration-500">
                                <span className="absolute top-5 right-5 px-4 py-1.5 rounded-full border border-[#C9A962]/40 text-[#C9A962] text-[10px] font-bold uppercase tracking-[0.15em]">
                                    {c.start}
                                </span>
                                <span className="w-12 h-12 rounded-full border border-[#C9A962]/40 flex items-center justify-center text-[#C9A962] mb-6">
                                    {i === 0 ? <GraduationCap size={20} /> : <Video size={20} />}
                                </span>
                                <h3 className="font-display text-2xl lg:text-3xl font-semibold text-[#F0EBE0]">{c.name}</h3>
                                <p className="mt-2 font-display italic text-[#A19D94]">{c.tagline}</p>
                                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#5C5A56]">{c.mode}</p>

                                <div className="mt-6 flex items-baseline gap-3">
                                    <BadgeIndianRupee size={18} className="text-[#C9A962] self-center" />
                                    <span className="font-mono-num text-4xl font-light text-[#C9A962]">{c.price}</span>
                                    <span className="font-mono-num text-lg text-[#5C5A56] line-through">{c.oldPrice}</span>
                                </div>

                                <ul className="mt-6 space-y-2.5 flex-1">
                                    {c.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2.5 text-sm text-[#A19D94]">
                                            <Check size={15} className="text-[#C9A962] mt-0.5 shrink-0" /> {f}
                                        </li>
                                    ))}
                                </ul>

                                <div className="mt-6 flex flex-wrap gap-2">
                                    {c.perks.map((p) => (
                                        <span key={p} className="px-3 py-1.5 rounded-full bg-[#C9A962]/5 border border-[#C9A962]/20 text-[11px] text-[#C9A962]/90">{p}</span>
                                    ))}
                                </div>

                                <a data-testid={`course-enrol-${i}`} href={waLink(c.wa)} target="_blank" rel="noopener noreferrer"
                                    className="mt-8 w-full py-4 rounded-full bg-[#C9A962] text-[#081226] text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#dcc083] hover:shadow-[0_0_30px_rgba(201,169,98,0.45)] transition-all flex items-center justify-center gap-2">
                                    <MessageCircle size={16} /> Enrol via WhatsApp
                                </a>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
